import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import roleSchema from "~/forms/RoleForm/roleSchema";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import RoleForm from "~/forms/RoleForm";
import manageCompanySelectors from "~/store/manageCompanies/selectors";
import manageCompaniesActionCreators from "~/store/manageCompanies/actions";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ManageCompanyRoleUpdateModal = () => {
  const {
    t
  } = useTranslation();
  const company = useSelector(manageCompanySelectors.getSelected);
  const companyId = company?.id || "";
  const roleId = useSelector(manageCompanySelectors.getSelectedData);
  const status = useSelector(manageCompanySelectors.getStatusByCompany(companyId));
  const error = useSelector(manageCompanySelectors.getErrorByCompany(companyId));
  const dispatch = useDispatch();
  const role = company?.roles.find(r => r.id === roleId);
  const defaultValues = {
    name: role?.name || "",
    description: role?.description || "",
    weight: role?.weight || 0,
    authorities: role?.authorities || []
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    resolver: yupResolver(roleSchema),
    defaultValues
  });
  useEffect(() => {
    if (company) {
      reset(defaultValues);
    }
  }, [reset, roleId]);
  const onSubmit = handleSubmit(data => {
    if (roleId) {
      dispatch(manageCompaniesActionCreators.updateRoleStarted(companyId, roleId, data, _ref => {
        let {
          data: newRole
        } = _ref;
        if (newRole) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("RoleUpdateModal.roleUpdated", {
              name: `${newRole.name}`
            }),
            timeout: 10000
          }));
        }
      }));
    }
  });
  const handleCancel = () => {
    dispatch(manageCompaniesActionCreators.actionChanged(null, null));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("RoleUpdateModal.updateRole"),
    onClose: handleCancel,
    maxWidth: "560px",
    fullWidth: true,
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(RoleForm, {
    control: control,
    watch: watch,
    setValue: setValue,
    authorities: company?.authorities || []
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("RoleUpdateModal.saveRole")))));
};
export default ManageCompanyRoleUpdateModal;